/*
 * Copyright Mimic Networks, Inc. 2025.
 */
import { Link } from 'react-router-dom';

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Text } from '@/primitives/Text';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';

import './WindowsReleaseInstructions.css';

export type WindowsReleaseInstructionsProps = {
  packageType: string;
};

export function WindowsReleaseInstructions({ packageType }: WindowsReleaseInstructionsProps) {
  const { t } = useMimicTranslation('downloadNode');
  const tenantId = useMgmtPlaneStateStore((state) => state.selectedTenantID);
  const installerType = packageType === 'exe' ? 'exe' : 'msi';

  return (
    <ol className="windows-release-instructions-steps">
      <li>
        <Text>{t('installInstructions.step1.prefix')} </Text>
        <Link to={`/tenants/${tenantId}/installer-tokens`}>
          <Text type="link">{t('installInstructions.step1.linkText')}</Text>
        </Link>
        <Text>{t('installInstructions.step1.suffix')}</Text>
      </li>
      <li>
        <Text style={{ marginBottom: '100px' }}>{t(`installInstructions.${installerType}.step2.text`)}</Text>
        <div className="windows-release-instructions-command">
          {t(`installInstructions.${installerType}.step2.command`)}
        </div>
        {packageType === 'exe' && (
          <section>
            <div className="windows-release-instructions-or">
              {' '}
              {t('installInstructions.exe.step2.graphicalOption')}{' '}
            </div>
            <div> {t('installInstructions.exe.step2.graphical')} </div>
          </section>
        )}
        {packageType === 'msi' && (
          <section>
            <div className="windows-release-instructions-or"> {t('installInstructions.exe.step2.msiNote')} </div>
            <div> {t('installInstructions.exe.step2.graphicalAlternative')} </div>
          </section>
        )}
      </li>
      <li>
        <Text>{t('installInstructions.step3.prefix')} </Text>
        <Link to={`/tenants/${tenantId}/nodes`}>
          <Text type="link">{t('installInstructions.step3.linkText')}</Text>
        </Link>{' '}
        <Text>{t('installInstructions.step3.suffix')}</Text>
      </li>
    </ol>
  );
}
